import React, { useEffect, useState } from "react";
import { Delete, Pen } from "lucide-react";
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { createUnit, deleteUnit, fetchUnits, updateUnit } from "../../../../slices/company/unitsSlice";
import UnitForm from "./unit_form";
import { customTableStyles } from "../../../../utils/tableStylings";

const Units = () => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false); // To control modal visibility
    const [selectedUnits, setSelectedUnit] = useState(null);
    const [modalHeading, setModalHeading] = useState('');
    const { units } = useSelector(state => state.accountingUnits);

    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            const companyId = company.company?.id;
            dispatch(fetchUnits(companyId));
        }
    }, [dispatch]);

    const handleFormSubmit = (formData) => {
        if (selectedUnits && selectedUnits?.id != null) {
            dispatch(updateUnit({ id: selectedUnits.id, taxData: formData }));

        } else {

            dispatch(createUnit(formData));
        }
        setShowModal(false);
    };


    const handleEditTax = (unitdata) => {
        setSelectedUnit(unitdata);
        setModalHeading('Edit Unit') // Pass the supplier data to edit
        setShowModal(true);
    };

    const handleDelete = (taxId) => {
        Swal.fire({
            title: '<strong>Are you sure?</strong>',
            html: `<p>This action will <b>permanently delete</b> this Unit.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteUnit(taxId));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The Unit has been deleted.',
                    toast: true,          // Enable toast style
                    position: 'top-end',  // Position at the top-right corner
                    showConfirmButton: false,  // Hide the confirm button
                    timer: 3000,          // Set the timer to auto-close after 3 seconds
                    timerProgressBar: true,  // Show the progress bar for the timer
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });

            }
        });

    };


    const unitColumn = [
        {
            name: '#',
            cell: (row, index) => index + 1, // Show index of the row
            width: '50px'
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true
        },

        {
            name: 'Actions',
            cell: row => (
                <>
                    <span
                        className="text-warning cursor-pointer me-2"
                        onClick={() => handleEditTax(row)}
                    >
                        <Pen />
                    </span>
                    <span
                        className="text-danger cursor-pointer"
                        onClick={() => handleDelete(row.id)}
                    >
                        <Delete />
                    </span>
                </>
            ),
            width: '150px'
        }
    ];

    const handleAdd = () => {
        setSelectedUnit([]);
        setModalHeading('Create Unit');// No supplier means we are adding a new one
        setShowModal(true);
    };



    return (
        <>
            <div className="card">
                <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="text-primary mb-0">Units</h3>
                        <button
                            className="btn btn-primary"
                            onClick={() => handleAdd()}
                        >
                            + Add Unit
                        </button>
                    </div>
                </div>
                <div className="card-body">

                    {
                        units && units.length > 0 ? (
                            <DataTable

                                columns={unitColumn}
                                data={units}
                                pagination
                                highlightOnHover
                                striped
                                dense
                                customStyles={customTableStyles}
                            />
                        ) : (
                            <p>No Data Found</p>
                        )
                    }
                </div>
            </div>
            <UnitForm show={showModal} onClose={() => setShowModal(false)} heading={modalHeading} initialData={selectedUnits} onSubmit={handleFormSubmit} />
        </>
    );
}

export default Units;